/**
 * To set the selected tab from one of 'Schematic', 'Evaluation Boards' and 'Samples'
 * @type {string}
 */
export const SET_SELECTED_TAB = 'SET_SELECTED_TAB';

/**
 * To set the selected values of 'application', 'sensorType', 'optimization' filters and 'solutionId'
 * @type {string}
 */
export const SET_SELECTED_FILTERS = 'SET_SELECTED_FILTERS';
